'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

require('./PopupList.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var PopupList = function PopupList(_ref) {
    var title = _ref.title,
        actions = _ref.actions,
        children = _ref.children,
        list = _ref.list;

    var mappableList = (0, _lodash.isArray)(list) ? list : list.valueSeq();
    return _react2.default.createElement(
        'div',
        { className: 'PopupList' },
        _react2.default.createElement(
            'div',
            { className: 'list-header' },
            _react2.default.createElement(
                'span',
                { className: 'list-title' },
                title
            ),
            _react2.default.createElement(
                'div',
                { className: 'actions' },
                actions
            )
        ),
        _react2.default.createElement(
            'ul',
            { className: 'popup-list' },
            mappableList.map(function (listItem, index) {
                return _react2.default.createElement(
                    'li',
                    { key: index },
                    children(listItem, index)
                );
            })
        )
    );
};

// Styles


PopupList.propTypes = {
    title: _propTypes2.default.string,
    actions: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
    children: _propTypes2.default.func.isRequired,
    list: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
};

exports.default = PopupList;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/types/PopupList.js
// module id = 714
// module chunks = 0